import { render, staticRenderFns } from "./PageCategoriesCreate.vue?vue&type=template&id=2b6f2ce1&scoped=true&"
import script from "./PageCategoriesCreate.vue?vue&type=script&lang=ts&"
export * from "./PageCategoriesCreate.vue?vue&type=script&lang=ts&"
import style0 from "./PageCategoriesCreate.vue?vue&type=style&index=0&id=2b6f2ce1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6f2ce1",
  null
  
)

export default component.exports